import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import { formatData } from './helper';
import { filterColorSelector } from '../base/selectors';
import { IMPROVEMENT_OPPORTUNITY_METRICS } from '@src/utils/kpi';
import { AdContentTabKey, ChartsTabKey } from './reducer';
import { formatAdStartupContentData } from './adContentHelper';
import { currentMetricsMetaSelector } from '@store/common/selectors';

const selector = (state) => get(state, SCOPE);

export const activeTabSelector = createSelector(selector, (state) => state.base.activeTab);
export const chartsSelector = createSelector(selector, (state) => state[ChartsTabKey]);
export const adContentSelector = createSelector(selector, (state) => state[AdContentTabKey]);

export const chartLoadingSelector = createSelector(chartsSelector, (chartsStore) => ({
  loading: chartsStore.isFetching,
  showError: chartsStore.errorCode !== 0 || chartsStore.errorMsg,
  errorMsg: chartsStore.errorMsg,
}));

export const chartDataSelector = createSelector(
  chartsSelector,
  filterColorSelector,
  currentMetricsMetaSelector,
  (chartsStore, filterColor, currentMetricsMeta) => {
    return formatData({
      response: chartsStore.response,
      metrics: IMPROVEMENT_OPPORTUNITY_METRICS,
      filterColor,
      allMetrics: currentMetricsMeta,
    });
  },
);

export const adContentLoadingSelector = createSelector(adContentSelector, (adContentStore) => ({
  loading: adContentStore.isFetching,
  showError: adContentStore.errorCode !== 0 || adContentStore.errorMsg,
  errorMsg: adContentStore.errorMsg,
}));

export const adContentDataSelector = createSelector(adContentSelector, (adContentStore) => {
  return formatAdStartupContentData(adContentStore.response);
});

export default selector;
